import React from 'react';
const BULLETS = ['La presión del consultorio no es decisión propia.', 'La urgencia comercial no es claridad financiera.', 'El deseo del resultado no es estar lista para el proceso.', 'Subestimar la recuperación no es fortaleza — es falta de información.', 'Llegar sin estructura no es valentía — es improvisar una decisión importante.'];
export function EmotionalAgitation() {
  return <section className="pull-quote-section" data-id="element-13">
      <blockquote className="pull-quote" data-id="element-14">
        Muchas mujeres pasan más tiempo planeando unas vacaciones que una
        decisión permanente sobre su cuerpo.
      </blockquote>

      <ul className="sober-list" data-id="element-15">
        {BULLETS.map((b, idx) => <li key={idx} className="sober-item" data-id="element-16">
            <span className="sober-item-mark" data-id="element-17">—</span> {b}
          </li>)}
      </ul>
    </section>;
}